export const MESSAGE_TEMPLATE_MODEL = "message-template";

const messageTemplateModel = {
  category: "",
  subject: "",
  body: "",
  tags: [],
  attachments: []
};

export default messageTemplateModel;
